import * as React from 'react';
import ComponentBasic from 'kts-scaffold-framework/component/ComponentBasic';
import { Dropdown, Menu, Icon } from 'antd';

const css = require('./index.scss');

export class GroupButtonState {

}

export interface GroupButtonProps {

    /** 按钮列表 */
    buttons: ButtonItem[];

    /** 渲染按钮方法 */
    buttonRender?: (value: ButtonItem, index:number) => JSX.Element;

    /** 显示按钮的数量 */
    buttonQuantity?: number;
}

export interface ButtonItem {

    /** 标题 */
    title: string | JSX.Element;

    /** 回掉函数 */
    onClick?: (value: ButtonItem) => void;
}

export default class GroupButton extends ComponentBasic<GroupButtonProps, GroupButtonState> {

    state: GroupButtonState = new GroupButtonState();

    render() {
        return (
            <div className={`${css['group-button']}`} >
                {this.renderButtonList}
                {this.dotDotDot}
            </div>
        );
    }

    /** 点击了按钮 */
    private onClickButton = (item: ButtonItem) => e => {
        if (item.onClick) {
            item.onClick(item);
        }
    }

    /** 点点点 */
    private get dotDotDot(): JSX.Element {
        if (this.props.buttons.length <= this.buttonQuantity) {
            return null;
        }

        return <Dropdown placement="bottomRight" overlay={<Menu className={css.menu}>{this.overlay}</Menu>} trigger={['click']}><Icon className={css.icon} type="Icon_more2" /></Dropdown>;
    }

    /** 点点点菜单 */
    private get overlay(): JSX.Element[] {
        const re: JSX.Element[] = [];
        for (let i = 2; i < this.props.buttons.length; i++) {
            re.push(
                <Menu.Item key={i} >
                    {this.defaultMenuItem(this.props.buttons[i])}
                </Menu.Item>
            );
        }
        return re;
    }

    /** 按钮数量 */
    private get buttonQuantity(): number {
        return this.props.buttonQuantity ? this.props.buttonQuantity : 2;
    }

    /** 渲染按钮列表 */
    private get renderButtonList(): JSX.Element[] {
        if (!this.props.buttons) {
            return [];
        }

        const re: JSX.Element[] = [];
        for (let i = 0; i < this.buttonQuantity && i < this.props.buttons.length; i++) {
            if (this.props.buttonRender) {
                re.push(this.props.buttonRender(this.props.buttons[i], i) || this.defaultButton(this.props.buttons[i], i));
            } else {
                re.push(this.defaultButton(this.props.buttons[i], i));
            }
        }
        return re;
    }

    /** 默认按钮 */
    private defaultButton(item: ButtonItem, index:number): JSX.Element {
        return <a key={index} className={`${css.button}`} onClick={this.onClickButton(item)} >{item.title}</a>;
    }

    /** 默认菜单 */
    private defaultMenuItem(item: ButtonItem): JSX.Element {
        return <a onClick={this.onClickButton(item)}>{item.title}</a>;
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/GroupButton/index.tsx